/**
 * React component responsible for creating an image container with set rules
 * To mostly be used for TwoColumn section setups, but can be expanded for more.
 *
 * Copyright (c) 2020 Coursera
 * Author: Kelvin Nguyen
 */
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames'
import styles from './Image.module.scss'

const Image = ({
  src,
  alt,
  className,
  align,
  maxHeight,
  maxWidth,
  children,
  ...props
}) => {
  const wrapperClass = cx(className, {
    [styles.itemsStart]: (align === 'left'),
    [styles.itemsEnd]: (align === 'right'),
    [styles.itemsCenter]: (align === 'center'),
  }, 'center-laptop flex-container')

  const imgStyle = {
    maxHeight,
    maxWidth,
  }

  return (
    <>
      <div className={wrapperClass}>
        <img src={src} alt={alt} style={imgStyle} {...props} />
      </div>
      {children}
    </>
  )
}

Image.defaultProps = {
  align: 'left',
  maxHeight: '450px',
  maxWidth: '100%',
}

Image.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  src: PropTypes.string,
  alt: PropTypes.string,
  align: PropTypes.oneOf(['left', 'right', 'center']),
  maxHeight: PropTypes.string,
  maxWidth: PropTypes.string,
  children: PropTypes.node,
}

export default Image
